import { render, staticRenderFns } from "./PurchasePriceReport.vue?vue&type=template&id=f1ee20b8&scoped=true"
import script from "./PurchasePriceReport.vue?vue&type=script&lang=js"
export * from "./PurchasePriceReport.vue?vue&type=script&lang=js"
import style0 from "./PurchasePriceReport.vue?vue&type=style&index=0&id=f1ee20b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ee20b8",
  null
  
)

export default component.exports